/* eslint-disable react-hooks/exhaustive-deps */
import React, {createContext, useContext, useMemo, useState} from 'react'

export interface PageLink {
  title: string
  path: string
  isActive: boolean
  isSeparator?: boolean
}

export interface PageDataContextModel {
  pageTitle?: string
  setPageTitle: (_title: string) => void
  pageDescription?: React.ReactNode
  setPageDescription: (_description: React.ReactNode) => void
  pageBreadcrumbs?: Array<PageLink>
  setPageBreadcrumbs: (_breadcrumbs: Array<PageLink>) => void
}

const PageDataContext = createContext<PageDataContextModel>({
  setPageTitle: (_title: string) => {},
  setPageBreadcrumbs: (_breadcrumbs: Array<PageLink>) => {},
  setPageDescription: (_description: React.ReactNode) => {},
})

const PageDataProvider: React.FC<{children?: React.ReactNode}> = ({children}) => {
  const [pageTitle, setPageTitle] = useState<string>('')
  const [pageDescription, setPageDescription] = useState<React.ReactNode>()
  const [pageBreadcrumbs, setPageBreadcrumbs] = useState<Array<PageLink>>([])
  const value: PageDataContextModel = useMemo(
    () => ({
      pageTitle,
      setPageTitle,
      pageDescription,
      setPageDescription,
      pageBreadcrumbs,
      setPageBreadcrumbs,
    }),
    [pageTitle, pageDescription, pageBreadcrumbs]
  )

  return <PageDataContext.Provider value={value}>{children}</PageDataContext.Provider>
}

function usePageData() {
  return useContext(PageDataContext)
}

export {PageDataProvider, usePageData}
